import { IconDefinition } from "@fortawesome/fontawesome-svg-core";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { clsx } from "clsx/lite";

type EmployeeAttendanceActionButtonProps = {
  icon: IconDefinition;
  active?: boolean;
  alwaysPrimary?: boolean;
  onClick: () => void;
};

export function EmployeeAttendanceActionButton({
  icon,
  active,
  onClick,
  alwaysPrimary,
}: EmployeeAttendanceActionButtonProps) {
  return (
    <button
      className={clsx(
        "size-7",
        "cursor-pointer",
        "rounded-md",
        "flex",
        "justify-center",
        "items-center",
        active && "bg-primary-50",
        (active || alwaysPrimary) && "text-primary",
      )}
      onClick={onClick}
    >
      <FontAwesomeIcon icon={icon} className="text-base" />
    </button>
  );
}
